<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size: 15px; font-weight: bold"
          >Manage truck documents -- {{ Truck.truck_no }}</small
        >
      </legend>
      <div>
        <form role="form" @submit.prevent="newDocument()">
          <div class="row">
            <input type="hidden" class="truck_id" :value="Truck.id" />
            <div class="col-md-12">
              <input
                type="file"
                class="form-control truck_log"
                accept="application/pdf"
                id="truckLogInput"
                @change="handleFileChange"
              /><br>
              <div v-if="file_name">
                <strong>Selected File:</strong> {{ file_name }}
              </div>
              <div v-if="file_preview">
                <strong>File Preview:</strong>
                <embed :src="file_preview" type="application/pdf" width="100%" height="500px" />
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-flat creatingTruckdocuments btn-rounded"
          >
            <i class="fa fa-truck"></i> Add log book
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat creatingTruckdocumentsLoader btn-rounded"
          >
            <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>please
            wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
import $ from "jquery";

export default {
  data() {
    return {
      file_name: "",
      file_content: null,
      file_preview: null, // Added to store file preview data URL
    };
  },
  created() {
    if (this.$store.getters.Truck.length === 0) {
      router.push("/managetrucks");
    }
  },
  computed: {
    ...mapGetters(["Truck"]),
  },
  methods: {
    ...mapActions(["newDocument"]),
    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      this.file_name = selectedFile.name;

      const reader = new FileReader();
      reader.onload = () => {
        this.file_content = reader.result;
        // Update the file preview when the file is loaded
        this.file_preview = reader.result;
      };
      reader.readAsDataURL(selectedFile);
    },
  },
};
</script>


<style scoped>
.creatingTruckdocumentsLoader {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/trucks/truckdocuments.vue